export const TAX_CATEGORIES_RESET_STATE = 'TAX_CATEGORIES_RESET_STATE';
export const TAX_CATEGORIES_CURRENT_ITEM = 'TAX_CATEGORIES_CURRENT_ITEM';

export const TAX_CATEGORIES_REQUEST_LOADING = 'TAX_CATEGORIES_REQUEST_LOADING';
export const TAX_CATEGORIES_REQUEST_SUCCESS = 'TAX_CATEGORIES_REQUEST_SUCCESS';
export const TAX_CATEGORIES_REQUEST_FAILED = 'TAX_CATEGORIES_REQUEST_FAILED';

export const TAX_CATEGORIES_CURRENT_ACTION = 'TAX_CATEGORIES_CURRENT_ACTION';
export const TAX_CATEGORIES_RESET_ACTION = 'TAX_CATEGORIES_RESET_ACTION';